export const NO_THANKS_MIN_PLAYERS = 2;